import { useCallback } from 'react';
import { useStore } from 'react-redux';
import { useServices } from 'core/common/hooks';
import { RootInitialState } from 'core/common/store';
import { isObject } from 'core/common/utils/isObject';
import { getConditionAttributes } from 'core/funnel/store';

export const useFlowContent = () => {
  const store = useStore<RootInitialState>();
  const { templateEngine } = useServices();

  const getTemplate = useCallback(
    (value: string) => {
      const template = templateEngine.compile(value);
      return template(getConditionAttributes(store.getState()));
    },
    [store, templateEngine],
  );

  const transformContentToTemplate = useCallback(
    (content: Record<string, unknown>) => {
      const copyContent = { ...content };

      Object.entries(copyContent).forEach(([key, value]) => {
        if (typeof value === 'string') {
          copyContent[key] = getTemplate(value);
          return;
        }

        if (Array.isArray(value)) {
          copyContent[key] = value.map((item) => {
            if (typeof item === 'string') {
              return getTemplate(item);
            }

            return transformContentToTemplate(item);
          });

          return;
        }

        if (isObject(value)) {
          copyContent[key] = transformContentToTemplate(value as Record<string, unknown>);
        }
      });

      return copyContent;
    },
    [getTemplate],
  );

  return { transformContentToTemplate };
};
